export default {
  init() {
    $('.elementor-image').addClass('wow fadeInUp');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singlePost.js